export const TTL_MINUTES = 15;
export const salesforceIdRegex = /^[A-Za-z0-9]{15}([A-Za-z0-9]{3})?$/;

export const isNullOrEmpty = (value: string[] | string | null) => {
  return value === null || value.length === 0;
};

export const wait = async (seconds: number) => {
  return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
};

export const cleanupExpiredOppInLocalStorage = (): void => {
  const currentTime = Date.now();
  const keysToRemove: string[] = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key || !salesforceIdRegex.test(key)) continue;

    try {
      const value = JSON.parse(localStorage.getItem(key) || '{}');
      if (value.time && currentTime - value.time > TTL_MINUTES * 60 * 1000) {
        keysToRemove.push(key);
      }
    } catch {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => localStorage.removeItem(key));
};
